import packageInfo from '../package.json'

export const getPackageInfo = () => {
	const { version, name } = packageInfo
	return { version, name }
}
